import React, { Component } from 'react'
import axios from 'axios';
import '../../css/BisharatMain.css';
import MemberDataService from '../../services/MemberDataService';
import authHeader from '../../services/AuthHeader';
import {ENV_URL} from '../../services/Globals';
export default class MemberProfilePic extends Component {
    state = {
        oneMember: [],
        selectedFile: null
    }

    componentDidMount() {
       this.refreshOneMember();
    }

    refreshOneMember = () => {
        const { match: { params } } = this.props;
        const id = params.id;
        MemberDataService.getMember(id)
            .then(res => {
                const oneMember = res.data;
                this.setState({ oneMember });
           });
        
    }

    fileSelectedHandler = event => {
        this.setState({
            selectedFile: event.target.files[0]
        })
    }

    fileUpalodHandler = () => {
        const fileData = new FormData();
        fileData.append('file', this.state.selectedFile)
        this.uploadProfileImage(fileData);
    }

    //Upload Image for Gallery 
    uploadProfileImage(data) {

        return axios.post(`${ENV_URL}/api/v1/members/${this.state.oneMember.id}/upload`, data,
            {
            headers: authHeader(),
            "Content-Type": "multipart/form-data"
            }
        ).then(res => {
            alert("Uploaded Successfully !");
            this.refreshOneMember();
            window.location.reload(false);
        }).catch(err => {
        })
    }



    render() {
        return (
            <div className="top-level-page-main member-profile-picture">
  <div className="view-profile">
  <div className="profile-details">
  <h4> Upload Profile Picture For {this.state.oneMember.name} </h4>
  
  
 
                         { this.state.oneMember.userProfileImageLink ? 
                            <img
                                src={`${ENV_URL}/api/v1/members/${this.state.oneMember.id}/download`}
                             alt="profile"
                        /> :
                      <h4> No Image Found  </h4>   
                    }
                          
<input type='file' onChange={this.fileSelectedHandler} />                    
<button className="btn" onClick={this.fileUpalodHandler}> Upload  </button>
</div>
<div className="actionsProfile">  

<button className="btn" onClick={this.props.history.goBack}> للعودة  </button>
  
 
      </div>
  </div>

            </div>



        )
    }
}


